<template>
    <div class="bread-crumb-bar">
      <div class="row">
        <div class="col-sm-12">
          <ul class="breadcrumb-path-container">
            <li class="breadcrumb-path" v-for="(crumb, index) in breadcrumbs"
              v-if='crumb!=""'>
              <router-link v-if="isClickable(index, crumb)"
                :to="link(index, crumb)" :key="index">
                {{ parseCrumb(crumb) }}
              </router-link>
              <span v-else> 
                {{ parseCrumb(crumb) }} 
              </span>
            </li>
            <!-- <router-link class="breadcrumb-path"
              v-for="(crumb, index) in breadcrumbs"
              :to="link(index)+'/'+crumb" v-if='crumb!=""'
              :key="index">
              {{ parseCrumb(crumb) }}
            </router-link> -->
          </ul>
        </div>
      </div>
    </div>
</template>


<script type="text/javascript">
import { mapState, mapGetters } from 'vuex';
import store from '../store';
import { dashboard_routes } from '../routes'
import _ from 'lodash';
let current = '';

export default {
  props:{
    flag:{
      default: 'jamaica.svg'
    }
  },

  data () {
    return {
      url: '',
    }
  },
  computed: {
    ...mapState({
      selectedMea: state => state.selectedMea,
      selectedUser: state => state.selectedUser,
      selectedDataSource: state => state.selectedDataSource,
      selectedTagName: state => state.selectedTag.name,
      selectedRoleName: state => state.selectedRole.name,
      selectedGroupName: state => state.selectedGroup.name,
      selectedReminderName: state => state.selectedReminder.label,
      selectedIndicatorName: state => state.selectedIndicator.name,
      selectedReportName: state => state.reportObject.name,
      selectedOrganizationName: state => state.selectedOrganization.name,
    }),
    ...mapGetters([
      // 'getMouByName',
      // 'getSelectedReminderByLabel',
    ]),
    routes: function() {
      let sub_list = [];
      let routes = dashboard_routes;

      for (var i=0; i<routes.length; i++) {
        if (routes[i].meta.name == 'Reminders' || routes[i].meta.name == 'Profile'){
          if(this.isPermitted(routes[i])) sub_list.push(routes[i]);
        }
      }
      return sub_list
    },
    source: function(){
      return require('./../assets/' + this.flag);
    },
    userName: function () {
      let userName = '';
      if (store.state.selectedUser !== undefined) {
         userName = `${this.selectedUser.first_name} ${this.selectedUser.last_name}`;
      }
      return userName;
    },
    breadcrumbs: function(){
      return this.$route.fullPath.split('/');
    },
  },

  methods:{
    isPermitted: function(route){
        return store.getters.hasPerm(route.meta.requiresPerm);
    },
    
    isClickable: function(index, crumb) {
      let url = this.breadcrumbs;
      
      if (url.length < 3) return false;
      else {
        let path = _.slice(url, 0, index);
        return ((path.length + 1) >= url.length)? false : true;
      }
    },

    link:function(index, crumb){
      let link = null;
      let url = this.$route.fullPath.split('/');
      let relativePath = _.slice(url, 0, index);
      
      for (let i=0;i<relativePath.length;i++) {
        let path = relativePath[i]
        link = ((path != "")? '/' + path : path) + '/';
      }
      
      link = link + crumb;
      if (!isNaN(crumb))
        link = link.concat('/', 'details');
      return link;
    },

    parseCrumb: function(crumb){
      let _crumb = '';
      
      if(isNaN(Number(crumb)) === true){
        current = crumb;
        _crumb = _.startCase(crumb);
      } else {
        _crumb = this.fetchIdentifier()
      }
      return _crumb;
    },

    fetchIdentifier:function(){
      let identifiers = {
        'users': this.userName,
        'meas': this.selectedMea.name,
        // 'mous': this.getMouByName,
        'data-sources': this.selectedDataSource.name,
        'reminders': _.capitalize(this.selectedReminderName),
        'organizations': this.selectedOrganizationName,
        'groups': this.selectedGroupName,
        'roles': this.selectedRoleName,
        'tags': this.selectedTagName,
        'indicators': this.selectedIndicatorName,
        'reports': this.selectedReportName,
        'groups': this.selectedGroupName
      };

      return identifiers[current];
    }
  }
};
</script>


<style lang="scss" scoped>
@import "../css/constants";

//Reset
.col-lg-1, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg-2, .col-lg-3, .col-lg-4,
.col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-md-1, .col-md-10,
.col-md-11, .col-md-12, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6,
.col-md-7, .col-md-8, .col-md-9, .col-sm-1, .col-sm-10, .col-sm-11, .col-sm-12,
.col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8,
.col-sm-9, .col-xs-1, .col-xs-10, .col-xs-11, .col-xs-12, .col-xs-2, .col-xs-3,
.col-xs-4, .col-xs-5, .col-xs-6, .col-xs-7, .col-xs-8, .col-xs-9 {
  padding: 0;
  margin: 0;
  width: auto;
}
.row {
  margin: 0;
  padding-top: $p24;
  padding-bottom: $p24;
  float: left;
}

.submenu-container{
  float: right;
  margin: 12px 0 0 0;

  ul.submenu-list {
    li:first-child { border: none; }
    li:last-child { a { margin-right: 0; } }
    li {
      display: inline-block;
      border-left: 1px solid $gray4;
      line-height: 1.3em;
      a {
        display: block;
        padding: 0 14px;
        
        .submenu-content {
          margin: 0 auto;
          text-align: center;
          .icons { margin: 0 auto; padding: 0; }
          span{ color: $gray6; display: block; font-size: $p14; }
        }
      }
    }
  }
}

.flag-box img{
  height:100%;
  width:100%;
}
.flag-box{
  height:15px;
  width: 21px;
}
.bread-crumb-bar{
  padding-left: $p24;
  margin-left: -$p24;
  padding-right: $p24;
  margin-right: -$p24;
  height: 45px;
  /*height: 35px;*/
  overflow: hidden;
  .row{
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
}
.bread-crumb-bar:before {}
.bread-crumb-bar:after {  content: ""; display: table; clear: both; }

ul.breadcrumb-path-container {
  line-height: 1.2;
  margin-left: $p14;
  font-size: 0.750em;
}

li.breadcrumb-path {
  display: inline-block;
  font-family:'Roboto Slab', serif;
  color: #4383bc;
  
  &:last-of-type{
    margin-left: 0;
  }
  
  a:focus, a:visited, a:active{ text-decoration: none; color: #4383bc; }
  &:after{
    content: url('../assets/right-arrow.svg');
    padding-right:5px;
    padding-left:5px;
  }

  &:last-of-type{
    &:after{
      content: none;
    }
  }
  
  span { color: #000; }
}

// @media (min-width: 576px){
//   .col-sm-1 {
//     -webkit-box-flex: 0;
//     -webkit-flex: 0 0 8.333333%;
//     -ms-flex: 0 0 8.333333%;
//     flex: 0 0 8.333333%;
//     max-width: 2.333333%;
//   }
// }

@media only screen and (max-width: 1190px) {
  /* For mobile phones: */
}

@media only screen and (min-width: 468px) and (max-width: 780px) {
  /* For mobile phones: */
  .bread-crumb-bar {
    display: none;;
  }
}

@media only screen and (max-width: 467px) {
  /* For mobile phones: */
  .bread-crumb-bar {
    display: none;;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/BreadCrumb.vue